<template>
  <div>
    <Header></Header>

    <div class="UsersList">
      <div class="UsersZg">Список участников
        <div class="UsersSwitcher" v-if="isAdmin">
          <a href="#" v-show="isSwitcherLink('facilitators')" @click.prevent="switchTo('facilitators')">Фасалитаторы</a>
          <span v-show="!isSwitcherLink('facilitators')">Фасалитаторы</span>
          <a href="#" v-show="isSwitcherLink('hidden')" @click.prevent="switchTo('hidden')">Скрытые</a>
          <span v-show="!isSwitcherLink('hidden')">Скрытые</span>
        </div>
      </div>

      <div class="User" v-for="user in users">
        <div class="Avatar" :style='{ backgroundImage: `url(${user.avatar_preview})` }'></div>
        <div class="Name" @click="goTo('user', { id: user.id })">{{ user.name }}</div>
        <div class="Email" v-if="canEdit">{{ user.email }}</div>
        <div class="Role" v-show="!canEdit">{{ roles[user.role] }}</div>
        <div class="RoleEdit" v-show="canEdit">
          <div class="RoleInput">
            <select v-model="user.role">
              <option v-for="(roleName, role) in roles" v-bind:value="role">
                {{ roleName }}
              </option>
            </select>
          </div>
          <div class="RoleSubmit" @click="saveRole(user)">Сохранить</div>
        </div>
        <br />
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import { ROLES } from "@/utils/roles";
import { API_ROOT } from "@/utils/api_root";
import { mapGetters } from 'vuex';
import store from "@/store";

export default {
  components: {
    Header
  },
  data() {
    return {
      roles: ROLES,
      show: 'facilitators'
    };
  },
  methods: {
    saveRole(user) {
      console.log('saveRole', user)
      this.$http.put(`${API_ROOT}/users/${user.id}/role/${user.role}.json`)
        .then(response => {
          this.flash('Роль сохранена', 'success', {timeout: 3000});
        })
        .catch(error => {
          console.log('saveRole error', error, error.response);
          this.flash('Ошибка сохранения', 'error');
          // this.cardOpisErrors = error.response.data;
        });
    },
    isSwitcherLink(type) {
      return this.show != type;
    },
    switchTo(newType) {
      this.show = newType;
      this.$store.dispatch('loadUsers', this.show);
    }
  },
  computed: {
    ...mapGetters(['currentUser', 'isAdmin']),
    users() {
      return this.$store.getters.users(this.show);
    },
    canEdit() {
      // console.log('currentUser', this.currentUser);
      return this.isAdmin;
    },
  },
  // beforeRouteEnter: async function (to, from, next) {
  created: async function() {
    console.log('Users component created, this.show', this.show);
    await this.$store.dispatch('loadUsers', this.show);
    // next();
  }
};
</script>

<style>

.UsersList{
  position: relative;
    margin: 15px auto 50px;
    min-width: 1000px;
    width: 85%;
    text-align: center;
    border: 0px solid #888888;
    /* height: 2800px; */
    /* display: block; */
    /* clear: both; */
}

.UsersZg{
  width: 100%;
  padding-left: 125px;
  padding-bottom: 40px;
  font-family: 'Roboto Condensed', sans-serif;
  color: #757575;
  text-align: left;
  font-weight: normal;
  font-size: 28px;
}

.UsersSwitcher{
  position: absolute;
  right: 80px;
  top: 15px;
  font-family: 'Roboto Condensed', sans-serif;
  color: #757575;
  font-weight: normal;
  font-size: 15px;
}

.UsersSwitcher a,
.UsersSwitcher span{
  padding: 0px 10px;
}

.User{
  position: relative;
    /* float: left; */
    margin: 10px;
    padding-left: 50px;
    width: 120px;
    height: 290px;
    text-align: left;
    border: 0px solid #cccccc;
    display: inline-table;
    clear: both;
}

.Avatar{
  width: 120px;
  height: 120px;
  border: 1px solid #cccccc;
  border-radius: 6px;
  background-size: cover;
}

.Name{
  padding-top: 20px;
  font-family: 'Roboto Condensed', sans-serif;
  color: #000;
  font-weight: 400;
  font-size: 20px;
  line-height: 1.1;
  cursor: pointer;
}

.Email{
  padding-top: 0px;
  font-family: 'Roboto', sans-serif;
  color: #888;
  font-weight: normal;
  font-size: 12px;
}

.Role{
  padding-top: 0px;
  font-family: 'Roboto', sans-serif;
  color: #888;
  font-weight: normal;
  font-size: 12px;
}

.RoleInput{
  margin-top: 20px;
  font-family: 'Roboto', sans-serif;
  color: #888;
  font-weight: normal;
  font-size: 12px;
}

.RoleSubmit{
  cursor: pointer;
  margin-top: 5px;
  padding: 5px 25px;
  width: 50px;
  border-radius: 4px;
  border: 1px solid #999;
  font-family: 'Roboto Condensed', sans-serif;
  color: #888;
  font-weight: normal;
  font-size: 12px;
}

</style>
